import { io } from 'socket.io-client';

import { url } from 'pages/Authorization';

// Derive the socket origin from the ONE place the API origin is decided, so a dev stack on a
// non-default port (REACT_APP_API_URL) moves the websocket with it instead of leaving it
// pointed at whatever backend happens to own :3000. Swapping the scheme on that value
// reproduces the previous literals exactly: https://api.sbly.com -> wss://api.sbly.com in a
// production build, http://localhost:3000 -> ws://localhost:3000 in dev.
const wsURL = url.replace(/^http/, 'ws');

const socket = io(wsURL, {
  transports: ['websocket'],
});

export default socket;
